
suggestedSsqs.classy.controller({
   name: 'suggestedSsqsController',
   inject: ['$scope', '$rootScope', 'authServiceFactory'],
   init: function()
   {
   		this.$.ssqList = [
   			{'question': "Does anyone outside your home contribute to your child(ren)'s tuition?"},
   			{'question': "Is someone else in your household or outside your household contributing to your expenses (boyfriend/girlfriend, grandparent, new spouse, etc.)?",
   				'subs': [
   					"If yes, who and how much is this person contributing to your expenses per month?"
   				]
   			},
   			{'question': "How much did your family spend on vacations last year?"},
            {'question': "Total monthly costs you pay for household help including nanny, gardener, pool services, housekeeper, driver, etc.",
               'subs': [
                  "If yes, please list and include expense for each."
               ]
            },
   			{'question': "Do you own any recreational vehicles? (boat, RV, motorcycle, etc.)",
   				'subs': [
   					"If yes, please list what recreational vehicles you own."
   				]
   			},
   			{'question': "Have you made any renovations to your home in the last two years?",
   				'subs': [
   					"If yes, please indicated what was done, when, and cost."
   				]
   			},
   			{'question': "Are you or any other adults in your household currently enrolled in a school or college?",
   				'subs': [
   					"If yes, what is the annual cost? What degree are they pursuing? Why are they pursuing that objective at this time?"
   				]
   			},
   			{'question': "Do you receive any other financial assistance and/or income not included in your annual income?",
      				'subs': [
      					"If so, please specify. If not applicable, enter N/A."
      				]
      			},
   			{'question': "Do you belong to a church or synagogue?",
      				'subs': [
      					"If yes, which one?"
      				]
      			}
   		];
   }

});

